var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('view-selector'),_c('input-sample-dashboard',{style:(_vm.showSampleDashboard)}),_c('input-heatmap',{style:(_vm.showHeatmap)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }